/**
 * Special bet combinations model
 */
export default class SpecialBetCombinationsModel {
  constructor(data) {
    /**
     * Name of the enabled special bet combination
     * @type {string}
     */
    this.name = data.Name;
    /**
     * Id of the enabled special bet combination
     * @type {number}
     */
    this.id = data.Id;
    /**
     * Localized name of the enabled special bet combination
     * @type {string}
     */
    this.nameLocalized = data.NameLocalized;
    /**
     * Required number of selections for the enabled special bet combination to be valid/appear
     * @type {number}
     */
    this.reqSelections = data.ReqSelections;
    /**
     * Array of objects with Value and Key of the  folds that form the specific bet combination
     * @type {number[]}
     */
    this.inclCombinations = (data.InclCombinations || []).map(i => i.Key);
    /**
     * Description of the enabled special bet combination
     * @type {string}
     */
    this.desc = data.Desc;
  }
}
